import { render, staticRenderFns } from "./dutyMediator.vue?vue&type=template&id=3dd35155&scoped=true&"
import script from "./dutyMediator.vue?vue&type=script&lang=js&"
export * from "./dutyMediator.vue?vue&type=script&lang=js&"
import style0 from "./dutyMediator.vue?vue&type=style&index=0&id=3dd35155&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd35155",
  null
  
)

export default component.exports